import { CaseServiceModel } from './case-service.model';

export class CaseServiceViewModel extends CaseServiceModel {
}
